export default __webpack_public_path__ + "static/B0036-f59ddb0418548df5a62a670d6ed962ad.png";